<div class="w-full flex gap-2 items-center">
  <div
    class="flex-1 flex items-center gap-2 px-3 py-2 border border-[var(--border)] rounded-lg"
    *ngIf="hasValue()"
  >
    <span class="text-[var(--text)] font-mono"> {{ formatIban() }} </span>
  </div>
  <div
    class="flex-1 flex items-center gap-2 px-3 py-2 border border-[var(--border)] rounded-lg text-[var(--text-light)]"
    *ngIf="!hasValue()"
  >
    <span>____ _____ _____ ___________ __</span>
  </div>

  <button
    mat-icon-button
    (click)="openEditDialog()"
    matTooltip="Éditer"
    [disabled]="disabled"
  >
    <mat-icon>edit</mat-icon>
  </button>

  <button
    mat-icon-button
    (click)="clear()"
    matTooltip="Effacer"
    [disabled]="disabled || !hasValue()"
  >
    <mat-icon>delete</mat-icon>
  </button>
</div>
